import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_CONFIG } from '../config';
import styles from './DevLoginPage.module.css';

interface User {
  id: number;
  name: string;
  email: string;
  role: string;
}

const DevLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Fonction pour se connecter en tant qu'utilisateur spécifique (mode développement uniquement)
  const impersonateUser = async (id: number): Promise<void> => {
    setLoading(true);
    
    try {
      // Faire une requête au point de terminaison de connexion de développement
      const response = await axios.post(`${API_CONFIG.BASE_URL}/api/dev/login/${id}`);
      
      // Extraire l'utilisateur (le token est géré automatiquement par le backend)
      const { user } = response.data;
      
      // Typage explicite de l'utilisateur pour s'assurer que l'interface User est utilisée
      const typedUser: User = user;
      
      // Rediriger selon le rôle de l'utilisateur
      if (typedUser.role === 'org_admin') {
        // Rediriger les organisations vers leur page d'organisation
        navigate('/org');
      } else {
        // Rediriger les utilisateurs standards vers la page de découverte
        navigate('/');
      }
      
      // Afficher une alerte de succès
      alert(`Connexion réussie : ${response.data.message}`);
    } catch (error) {
      console.error('Erreur d\'impersonnation:', error);
      alert('Impossible d\'impersonner cet utilisateur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Page de développement</h2>
      
      <div className={styles.card}>
        <div className={styles.cardContent}>
          {loading && <div className={styles.loadingOverlay}>Chargement...</div>}
          
          <h3 className={styles.subtitle}>Impersonnation d'utilisateur</h3>
          <p className={styles.description}>
            Cette page est uniquement à des fins de développement. 
            Elle vous permet de vous connecter rapidement en tant qu'utilisateur pour tester l'application.
          </p>
          
          <div className={styles.buttonGroup}>
            <button 
              className={styles.button}
              disabled={loading}
              onClick={() => impersonateUser(1)}
            >
              Utilisateur Étudiant (ID: 1)
            </button>
            
            <button 
              className={`${styles.button} ${styles.outlineButton}`}
              disabled={loading}
              onClick={() => impersonateUser(2)}
            >
              Organisation (ID: 2)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevLoginPage;
